import { Asset, Scripts, useRouter, useTags } from "@tanstack/react-router";
import type { ReactNode } from "react";

export function RootDocument({ children, lang }: Readonly<{ children: ReactNode; lang: string }>) {
  const tags = useTags();
  const nonce = useRouter().options.ssr?.nonce;
  const structuredData = tags.filter(
    (tag) => tag.tag === "script" && tag.attrs?.type === "application/ld+json",
  );
  const headTags = tags.filter((tag) => !structuredData.includes(tag));

  return (
    <html lang={lang} className="notranslate" translate="no">
      <head>
        {headTags.map((tag) => (
          <Asset key={`tsr-meta-${JSON.stringify(tag)}`} {...tag} nonce={nonce} />
        ))}
      </head>
      <body>
        {children}
        {/* Keep route data scripts outside the head that the tag gateway rewrites. */}
        {structuredData.map((tag) => (
          <Asset key={`tsr-meta-${JSON.stringify(tag)}`} {...tag} nonce={nonce} />
        ))}
        <Scripts />
      </body>
    </html>
  );
}
